import { useBootstrap } from '../../composables/bootstrap';

// MVK-3905 — modal adapter cho trang Bootstrap (entry `app`). Mỏng có chủ ý: uỷ quyền cho composable để giữ nguyên hành vi
// cũ, kể cả cờ `_isShown` lúc backdrop còn fade. Composable nhận id hoặc phần tử, adapter chỉ đổi tên cho khớp hợp đồng.
const { openModal, closeModal, onModalShow, isModalShown } = useBootstrap();

export default {
    show: openModal,
    hide: closeModal,
    onShow: onModalShow,
    isShown: isModalShown,
};
